"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _base = _interopRequireDefault(require("@atlaskit/icon/base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const PdfDocument48Icon = props => /*#__PURE__*/_react.default.createElement(_base.default, Object.assign({
  dangerouslySetGlyph: `<svg width="48" height="64" viewBox="0 0 48 64" role="presentation"><g fill-rule="evenodd"><path fill="#FFF" stroke="#091E42" stroke-opacity=".08" d="M4 .5h28.007a3.5 3.5 0 012.52 1.072l11.994 12.45a3.5 3.5 0 01.979 2.429V60a3.5 3.5 0 01-3.5 3.5H4A3.5 3.5 0 01.5 60V4A3.5 3.5 0 014 .5z"/><path fill="#FF5630" d="M15.654 32.197v-1.804h1.014c.64 0 .953.295.953.9 0 .53-.102.904-1.403.904h-.564zm7.337 2.548h.776c.865 0 1.751-.257 1.751-2.165 0-1.923-.936-2.17-1.751-2.17h-.776v4.335zm-7.784 1.91h-1.26a.448.448 0 01-.447-.448v-7.26c0-.246.2-.447.447-.447h2.91c1.73 0 2.94 1.148 2.94 2.793 0 1.667-1.184 2.788-2.946 2.788h-1.197v2.126c0 .247-.2.448-.447.448zm8.692 0h-2.614a.448.448 0 01-.447-.448v-7.26c0-.246.2-.447.447-.447h2.614c2.459 0 3.813 1.443 3.813 4.065 0 2.637-1.354 4.09-3.813 4.09zm6.738 0h-1.26a.448.448 0 01-.448-.448v-7.26c0-.246.2-.447.447-.447h4.677c.246 0 .447.201.447.447v1.026a.447.447 0 01-.447.447h-2.969v1.33h2.674c.247 0 .447.2.447.447v1.011c0 .246-.2.447-.447.447h-2.674v2.552c0 .247-.2.448-.447.448z"/></g></svg>`
}, props, {
  width: 48,
  height: 64
}));

PdfDocument48Icon.displayName = 'PdfDocument48Icon';
var _default = PdfDocument48Icon;
exports.default = _default;